import { Component } from '@angular/core';
import { newsnevents } from 'src/app/constant/auto/newsnevents.constant';

@Component({
  standalone: false,
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent {

  readonly newsNEvents = newsnevents;
  constructor() {
    this.newsNEvents = newsnevents;
  }
} 
